import { DocumentIcon, FlagIcon, ShieldCheckIcon, TimeIcon, UserIcon } from "./icons/IconPack"
import { LahzeNegarLogo, NeshanLogo, PasargadLogo, ZarinPalLogo } from "./icons/LogoPack"

const HomeProducts = [
    {
        id: 1,
        name: 'شبکه توزیع محتوا',
        description: 'شبکه توزیع محتوای ابر آروان شبکه‎‌ای امن و گسترده برای تحویل محتوای وب‌سایت شماست تا به کمک آن برای کاربران‌تان در سراسر جهان در دسترس باشید. با راه‌اندازی سریع، پایداری بالا و امکانات کامل این محصول مانند DNS و امنیت ابری، دیگر دغدغه‌ی تامین منابع زیرساختی و امنیت سرویس خود را نخواهید داشت.',
        imgUrl: '/images/cdn-desktop.svg'
    },
    {
        id: 2,
        name: 'سرور ابری',
        description: 'با سرورهای ابری مقیاس‌پذیر و مقرون به صرفه‌ی ابر آروان در بهترین دیتاسنترهای ایران و اروپا با منابع و سیستم‌عامل دلخواه به تعداد نامحدود سرور (ابرک) بسازید و به ‌شکل آنی منابع آن را افزایش دهید. شما می‌توانید به‌کمک فایروال و شبکه‌های خصوصی و عمومی سرور ابری آروان، سطوح دسترسی متفاوتی برای سرور خود در نظر بگیرید و با گرفتن اسنپ‌شات به وضعیت قبلی آن بازگردید.',
        imgUrl: '/images/cloud-computing-desktop.svg'
    },
    {
        id: 3,
        name: 'فضای ابری',
        description: 'با فضای ابری آروان از نوع Object Storage، امکان ذخیره‌سازی هر نوع فایل یا داده‌ای را در محیط ابری، به‌شکل کاملن رمزنگاری شده خواهید داشت و از نقاط مختلف دنیا، به‌طور پایدار به یک سامانه‌ی ذخیره‌سازی امن و مقیاس‌پذیر دسترسی پیدا می‌کنید؛ بدون آن‌که نگران زیرساخت یا از دست رفتن اطلاعات باشید.',
        imgUrl: '/images/cloud-storage-desktop.svg'
    },
    {
        id: 4,
        name: 'پلتفرم ویدیو',
        description: 'پلتفرم ویدیو ابر آروان بستری امن و در دسترس برای محتوای ویدیویی و صوتی شماست. با سرویس میزبانی ویدیو، فیلم‌ها و ویدیوهای خود را در فضای ابری نامحدود نگهداری کنید و آن را با کیفیت‌ها و فرمت‌های متفاوت به دست کاربران‌تان برسانید. هم‌چنین‌ با پخش زنده‌ ابر آروان می‌توانید استریم خود را با کم‌ترین تاخیر و بهترین کیفیت، بدون اختلال در معرض دید میلیون‌ها کاربر قرار دهید.',
        imgUrl: '/images/video-platform-desktop.svg'
    },
    {
        id: 5,
        name: 'کانتینر ابری',
        description: 'کانتینر ابری یا سکوی ابری آروان مبتنی بر Container و بر اساس استانداردهای Kubernetes است. شما می‌توانید تنها با یک دستور در CLI ایده‌های نرم‌افزاری خود را توسعه دهید و آن‌ها را به محصول تبدیل کنید. فرقی نمی‌کند نرم‌افزاری ساده یا پیچیده دیپلوی کنید؛ در کانتینر ابری (PaaS) آروان تمامی نیازمندی‌های زیرساختی شما به آسانی تامین می‌شود و با کنترل مداوم وضعیت زیرساخت، نرم‌افزارتان همیشه در دسترس خواهد بود.',
        imgUrl: '/images/paas-desktop.svg'
    },
]

const CustomersQuotes = [
    {
        id: 1,
        text: 'در لحظه‌نگار ترجیح می‌دهیم دغدغه‌ی مدیریت سرور و دپلوی کردن آن را نداشته باشیم. با استفاده از PaaS آروان، توسعه کلاستر داکر یا کوبرنتیز بر عهده ما نیست. ما دیگر دغدغه‌ی Maintenace کوبرنتیز نداریم و از پشتیبانی و سرعت پاسخ‌دهی تیم آروان هم رضایت داریم.',
        author: 'محمد حسین عابدین پور ؛ CTO لحظه نگار',
        img: <LahzeNegarLogo />,
    },
    {
        id: 2,
        text: 'ما در نماوا به‌طور ناگهانی در دوران قرنطینه، نیاز به راه‌اندازی سریع پخش زنده‌ی کنسرت‌ داشتیم. تیم فنی آروان پس از شنیدن نیازمندی‌ها و برآورد ترافیک به کمک ما آمدند و در کم‌تر از نصف روز توانستیم این سرویس را با هزینه‌ی منصفانه و بدون مشکل به کاربران‌مان ارایه‌ کنیم.',
        author: 'ناصر حیدری؛ مدیر زیرساخت نماوا',
        img: <img src="images/customers/namava.svg" loading="lazy" alt="نماوا" />,
    },
    {
        id: 3,
        text: 'مقیاس‌پذیری زیرساخت‌های ابری کمک می‌کند تا به تناسب رشد یک کسب‌وکار، دغدغه‌های زیرساختی نداشته باشید. در حال حاضر هر ۶ماه یک‌بار، تعداد کاربران و درخواست‌ها به‌سمت نشان دو برابر می‌شود و با زیرساخت ابری آروان نگرانی زیرساختی در این مسیر توسعه نیستیم.',
        author: 'مصطفی جملبادانی؛ مدیر فنی نشان',
        img: <NeshanLogo />,
    },
    {
        id: 4,
        text: 'ما در بانک پاسارگاد، به سمت استفاده از خدمات مقابله با DDoS بر بستر CDN رفتیم تا امن‌تر شویم و سرویس‌دهی سریع‌تری داشته باشیم. «دستیابی به امنیت و کاهش سطح ریسک» مهم‌ترین ارزش افزوده‌های خدمات ابر آروان برای بانک پاسارگاد بوده است.',
        author: 'نعمت الله کلانتری؛ مدیریت زیرساخت بانک پاسارگاد',
        img: <PasargadLogo />,
    },
    {
        id: 5,
        text: 'تمام خدمات تیم&nbsp;نقشه‌ی&nbsp;اسنپ که نیازمند&nbsp;CDN‌&nbsp;یا&nbsp;DNS&nbsp;است، از محصولات ابر آروان استفاده می‌کنند. روزانه میلیون‌ها کاربر تاکسی&nbsp; اسنپ، اسنپ فود، اسنپ مارکت، اسنپ&nbsp;باکس و اسنپ‌تریپ&nbsp;از نقشه‌ی اسنپ استفاده می‌کنند. با&nbsp;Load Balancer&nbsp; آروان، حدود ۹۹.۵ درصد ترافیک&nbsp;نقشه‌ی&nbsp;اسنپ صرفه‌جویی&nbsp;می‌شود.',
        author: 'علی کرمی؛ مدیر فنی نقشه اسنپ',
        img: <img src="images/customers/snapp.svg" loading="lazy" alt="اسنپ" />,
    },
    {
        id: 6,
        text: 'ابر آروان به‌معنای واقعی سرویس با کیفیت و در سطح روز دنیا عرضه می‌کند. در کنار فروش بلیت جشنواره‌ها، ما دو بلیت‌فروشی پرفشار را با استفاده از CDN ابر آروان، با موفقیت و بدون اختلال داشتیم و کاربران ما با مشکل یا کندی در وب‌سایت مواجه نشدند.',
        author: 'محمد عمروآبادی؛ مدیرعامل تیوال',
        img: <img src="images/customers/tiwall.svg" loading="lazy" alt="تیوال" />,
    },
    {
        id: 7,
        text: 'آروان باعث شده تمرکز زرین‌پال روی کار فنی خودش باشد و دغدغه‌ی زیرساختی نداریم. با گذشت زمان و بهتر شدن تیم فنی آروان، محصول هم بهبود محسوسی پیدا کرده است. من همیشه  CDN، DNS  و امنیت ابری آروان را به دوستان و مدیران کسب‌وکارها توصیه کرده‌ام و می‌کنم.',
        author: 'مصطفی امیری؛ مدیرعامل زرین‌پال',
        img: <ZarinPalLogo />,
    },
    {
        id: 8,
        text: 'در لحظه‌نگار ترجیح می‌دهیم دغدغه‌ی مدیریت سرور و دپلوی کردن آن را نداشته باشیم. با استفاده از PaaS آروان، توسعه کلاستر داکر یا کوبرنتیز بر عهده ما نیست. ما دیگر دغدغه‌ی Maintenace کوبرنتیز نداریم و از پشتیبانی و سرعت پاسخ‌دهی تیم آروان هم رضایت داریم.',
        author: 'محمد حسین عابدین پور ؛ CTO لحظه نگار',
        img: <LahzeNegarLogo />,
    },
    {
        id: 9,
        text: 'ما در نماوا به‌طور ناگهانی در دوران قرنطینه، نیاز به راه‌اندازی سریع پخش زنده‌ی کنسرت‌ داشتیم. تیم فنی آروان پس از شنیدن نیازمندی‌ها و برآورد ترافیک به کمک ما آمدند و در کم‌تر از نصف روز توانستیم این سرویس را با هزینه‌ی منصفانه و بدون مشکل به کاربران‌مان ارایه‌ کنیم.',
        author: 'ناصر حیدری؛ مدیر زیرساخت نماوا',
        img: <img src="images/customers/namava.svg" loading="lazy" alt="نماوا" />,
    },
    {
        id: 10,
        text: 'مقیاس‌پذیری زیرساخت‌های ابری کمک می‌کند تا به تناسب رشد یک کسب‌وکار، دغدغه‌های زیرساختی نداشته باشید. در حال حاضر هر ۶ماه یک‌بار، تعداد کاربران و درخواست‌ها به‌سمت نشان دو برابر می‌شود و با زیرساخت ابری آروان نگرانی زیرساختی در این مسیر توسعه نیستیم.',
        author: 'مصطفی جملبادانی؛ مدیر فنی نشان',
        img: <NeshanLogo />,
    },
    {
        id: 11,
        text: 'ما در بانک پاسارگاد، به سمت استفاده از خدمات مقابله با DDoS بر بستر CDN رفتیم تا امن‌تر شویم و سرویس‌دهی سریع‌تری داشته باشیم. «دستیابی به امنیت و کاهش سطح ریسک» مهم‌ترین ارزش افزوده‌های خدمات ابر آروان برای بانک پاسارگاد بوده است.',
        author: 'نعمت الله کلانتری؛ مدیریت زیرساخت بانک پاسارگاد',
        img: <PasargadLogo />,
    },
    {
        id: 12,
        text: 'تمام خدمات تیم&nbsp;نقشه‌ی&nbsp;اسنپ که نیازمند&nbsp;CDN‌&nbsp;یا&nbsp;DNS&nbsp;است، از محصولات ابر آروان استفاده می‌کنند. روزانه میلیون‌ها کاربر تاکسی&nbsp; اسنپ، اسنپ فود، اسنپ مارکت، اسنپ&nbsp;باکس و اسنپ‌تریپ&nbsp;از نقشه‌ی اسنپ استفاده می‌کنند. با&nbsp;Load Balancer&nbsp; آروان، حدود ۹۹.۵ درصد ترافیک&nbsp;نقشه‌ی&nbsp;اسنپ صرفه‌جویی&nbsp;می‌شود.',
        author: 'علی کرمی؛ مدیر فنی نقشه اسنپ',
        img: <img src="images/customers/snapp.svg" loading="lazy" alt="اسنپ" />,
    },
    {
        id: 13,
        text: 'ابر آروان به‌معنای واقعی سرویس با کیفیت و در سطح روز دنیا عرضه می‌کند. در کنار فروش بلیت جشنواره‌ها، ما دو بلیت‌فروشی پرفشار را با استفاده از CDN ابر آروان، با موفقیت و بدون اختلال داشتیم و کاربران ما با مشکل یا کندی در وب‌سایت مواجه نشدند.',
        author: 'محمد عمروآبادی؛ مدیرعامل تیوال',
        img: <img src="images/customers/tiwall.svg" loading="lazy" alt="تیوال" />,
    },
    {
        id: 14,
        text: 'آروان باعث شده تمرکز زرین‌پال روی کار فنی خودش باشد و دغدغه‌ی زیرساختی نداریم. با گذشت زمان و بهتر شدن تیم فنی آروان، محصول هم بهبود محسوسی پیدا کرده است. من همیشه  CDN، DNS  و امنیت ابری آروان را به دوستان و مدیران کسب‌وکارها توصیه کرده‌ام و می‌کنم.',
        author: 'مصطفی امیری؛ مدیرعامل زرین‌پال',
        img: <ZarinPalLogo />,
    },
    {
        id: 15,
        text: 'در لحظه‌نگار ترجیح می‌دهیم دغدغه‌ی مدیریت سرور و دپلوی کردن آن را نداشته باشیم. با استفاده از PaaS آروان، توسعه کلاستر داکر یا کوبرنتیز بر عهده ما نیست. ما دیگر دغدغه‌ی Maintenace کوبرنتیز نداریم و از پشتیبانی و سرعت پاسخ‌دهی تیم آروان هم رضایت داریم.',
        author: 'محمد حسین عابدین پور ؛ CTO لحظه نگار',
        img: <LahzeNegarLogo />,
    },
    {
        id: 16,
        text: 'ما در نماوا به‌طور ناگهانی در دوران قرنطینه، نیاز به راه‌اندازی سریع پخش زنده‌ی کنسرت‌ داشتیم. تیم فنی آروان پس از شنیدن نیازمندی‌ها و برآورد ترافیک به کمک ما آمدند و در کم‌تر از نصف روز توانستیم این سرویس را با هزینه‌ی منصفانه و بدون مشکل به کاربران‌مان ارایه‌ کنیم.',
        author: 'ناصر حیدری؛ مدیر زیرساخت نماوا',
        img: <img src="images/customers/namava.svg" loading="lazy" alt="نماوا" />,
    },
    {
        id: 17,
        text: 'مقیاس‌پذیری زیرساخت‌های ابری کمک می‌کند تا به تناسب رشد یک کسب‌وکار، دغدغه‌های زیرساختی نداشته باشید. در حال حاضر هر ۶ماه یک‌بار، تعداد کاربران و درخواست‌ها به‌سمت نشان دو برابر می‌شود و با زیرساخت ابری آروان نگرانی زیرساختی در این مسیر توسعه نیستیم.',
        author: 'مصطفی جملبادانی؛ مدیر فنی نشان',
        img: <NeshanLogo />,
    },
    {
        id: 18,
        text: 'ما در بانک پاسارگاد، به سمت استفاده از خدمات مقابله با DDoS بر بستر CDN رفتیم تا امن‌تر شویم و سرویس‌دهی سریع‌تری داشته باشیم. «دستیابی به امنیت و کاهش سطح ریسک» مهم‌ترین ارزش افزوده‌های خدمات ابر آروان برای بانک پاسارگاد بوده است.',
        author: 'نعمت الله کلانتری؛ مدیریت زیرساخت بانک پاسارگاد',
        img: <PasargadLogo />,
    },
    {
        id: 19,
        text: 'تمام خدمات تیم&nbsp;نقشه‌ی&nbsp;اسنپ که نیازمند&nbsp;CDN‌&nbsp;یا&nbsp;DNS&nbsp;است، از محصولات ابر آروان استفاده می‌کنند. روزانه میلیون‌ها کاربر تاکسی&nbsp; اسنپ، اسنپ فود، اسنپ مارکت، اسنپ&nbsp;باکس و اسنپ‌تریپ&nbsp;از نقشه‌ی اسنپ استفاده می‌کنند. با&nbsp;Load Balancer&nbsp; آروان، حدود ۹۹.۵ درصد ترافیک&nbsp;نقشه‌ی&nbsp;اسنپ صرفه‌جویی&nbsp;می‌شود.',
        author: 'علی کرمی؛ مدیر فنی نقشه اسنپ',
        img: <img src="images/customers/snapp.svg" loading="lazy" alt="اسنپ" />,
    },
    {
        id: 20,
        text: 'ابر آروان به‌معنای واقعی سرویس با کیفیت و در سطح روز دنیا عرضه می‌کند. در کنار فروش بلیت جشنواره‌ها، ما دو بلیت‌فروشی پرفشار را با استفاده از CDN ابر آروان، با موفقیت و بدون اختلال داشتیم و کاربران ما با مشکل یا کندی در وب‌سایت مواجه نشدند.',
        author: 'محمد عمروآبادی؛ مدیرعامل تیوال',
        img: <img src="images/customers/tiwall.svg" loading="lazy" alt="تیوال" />,
    },
    {
        id: 21,
        text: 'آروان باعث شده تمرکز زرین‌پال روی کار فنی خودش باشد و دغدغه‌ی زیرساختی نداریم. با گذشت زمان و بهتر شدن تیم فنی آروان، محصول هم بهبود محسوسی پیدا کرده است. من همیشه  CDN، DNS  و امنیت ابری آروان را به دوستان و مدیران کسب‌وکارها توصیه کرده‌ام و می‌کنم.',
        author: 'مصطفی امیری؛ مدیرعامل زرین‌پال',
        img: <ZarinPalLogo />,
    },
    {
        id: 22,
        text: 'در لحظه‌نگار ترجیح می‌دهیم دغدغه‌ی مدیریت سرور و دپلوی کردن آن را نداشته باشیم. با استفاده از PaaS آروان، توسعه کلاستر داکر یا کوبرنتیز بر عهده ما نیست. ما دیگر دغدغه‌ی Maintenace کوبرنتیز نداریم و از پشتیبانی و سرعت پاسخ‌دهی تیم آروان هم رضایت داریم.',
        author: 'محمد حسین عابدین پور ؛ CTO لحظه نگار',
        img: <LahzeNegarLogo />,
    },
    {
        id: 23,
        text: 'ما در نماوا به‌طور ناگهانی در دوران قرنطینه، نیاز به راه‌اندازی سریع پخش زنده‌ی کنسرت‌ داشتیم. تیم فنی آروان پس از شنیدن نیازمندی‌ها و برآورد ترافیک به کمک ما آمدند و در کم‌تر از نصف روز توانستیم این سرویس را با هزینه‌ی منصفانه و بدون مشکل به کاربران‌مان ارایه‌ کنیم.',
        author: 'ناصر حیدری؛ مدیر زیرساخت نماوا',
        img: <img src="images/customers/namava.svg" loading="lazy" alt="نماوا" />,
    },
    {
        id: 24,
        text: 'مقیاس‌پذیری زیرساخت‌های ابری کمک می‌کند تا به تناسب رشد یک کسب‌وکار، دغدغه‌های زیرساختی نداشته باشید. در حال حاضر هر ۶ماه یک‌بار، تعداد کاربران و درخواست‌ها به‌سمت نشان دو برابر می‌شود و با زیرساخت ابری آروان نگرانی زیرساختی در این مسیر توسعه نیستیم.',
        author: 'مصطفی جملبادانی؛ مدیر فنی نشان',
        img: <NeshanLogo />,
    },
    {
        id: 25,
        text: 'ما در بانک پاسارگاد، به سمت استفاده از خدمات مقابله با DDoS بر بستر CDN رفتیم تا امن‌تر شویم و سرویس‌دهی سریع‌تری داشته باشیم. «دستیابی به امنیت و کاهش سطح ریسک» مهم‌ترین ارزش افزوده‌های خدمات ابر آروان برای بانک پاسارگاد بوده است.',
        author: 'نعمت الله کلانتری؛ مدیریت زیرساخت بانک پاسارگاد',
        img: <PasargadLogo />,
    },
    {
        id: 26,
        text: 'تمام خدمات تیم&nbsp;نقشه‌ی&nbsp;اسنپ که نیازمند&nbsp;CDN‌&nbsp;یا&nbsp;DNS&nbsp;است، از محصولات ابر آروان استفاده می‌کنند. روزانه میلیون‌ها کاربر تاکسی&nbsp; اسنپ، اسنپ فود، اسنپ مارکت، اسنپ&nbsp;باکس و اسنپ‌تریپ&nbsp;از نقشه‌ی اسنپ استفاده می‌کنند. با&nbsp;Load Balancer&nbsp; آروان، حدود ۹۹.۵ درصد ترافیک&nbsp;نقشه‌ی&nbsp;اسنپ صرفه‌جویی&nbsp;می‌شود.',
        author: 'علی کرمی؛ مدیر فنی نقشه اسنپ',
        img: <img src="images/customers/snapp.svg" loading="lazy" alt="اسنپ" />,
    },
    {
        id: 27,
        text: 'ابر آروان به‌معنای واقعی سرویس با کیفیت و در سطح روز دنیا عرضه می‌کند. در کنار فروش بلیت جشنواره‌ها، ما دو بلیت‌فروشی پرفشار را با استفاده از CDN ابر آروان، با موفقیت و بدون اختلال داشتیم و کاربران ما با مشکل یا کندی در وب‌سایت مواجه نشدند.',
        author: 'محمد عمروآبادی؛ مدیرعامل تیوال',
        img: <img src="images/customers/tiwall.svg" loading="lazy" alt="تیوال" />,
    },
    {
        id: 28,
        text: 'آروان باعث شده تمرکز زرین‌پال روی کار فنی خودش باشد و دغدغه‌ی زیرساختی نداریم. با گذشت زمان و بهتر شدن تیم فنی آروان، محصول هم بهبود محسوسی پیدا کرده است. من همیشه  CDN، DNS  و امنیت ابری آروان را به دوستان و مدیران کسب‌وکارها توصیه کرده‌ام و می‌کنم.',
        author: 'مصطفی امیری؛ مدیرعامل زرین‌پال',
        img: <ZarinPalLogo />,
    },
    {
        id: 29,
        text: 'در لحظه‌نگار ترجیح می‌دهیم دغدغه‌ی مدیریت سرور و دپلوی کردن آن را نداشته باشیم. با استفاده از PaaS آروان، توسعه کلاستر داکر یا کوبرنتیز بر عهده ما نیست. ما دیگر دغدغه‌ی Maintenace کوبرنتیز نداریم و از پشتیبانی و سرعت پاسخ‌دهی تیم آروان هم رضایت داریم.',
        author: 'محمد حسین عابدین پور ؛ CTO لحظه نگار',
        img: <LahzeNegarLogo />,
    },
    {
        id: 30,
        text: 'ما در نماوا به‌طور ناگهانی در دوران قرنطینه، نیاز به راه‌اندازی سریع پخش زنده‌ی کنسرت‌ داشتیم. تیم فنی آروان پس از شنیدن نیازمندی‌ها و برآورد ترافیک به کمک ما آمدند و در کم‌تر از نصف روز توانستیم این سرویس را با هزینه‌ی منصفانه و بدون مشکل به کاربران‌مان ارایه‌ کنیم.',
        author: 'ناصر حیدری؛ مدیر زیرساخت نماوا',
        img: <img src="images/customers/namava.svg" loading="lazy" alt="نماوا" />,
    },
    {
        id: 31,
        text: 'مقیاس‌پذیری زیرساخت‌های ابری کمک می‌کند تا به تناسب رشد یک کسب‌وکار، دغدغه‌های زیرساختی نداشته باشید. در حال حاضر هر ۶ماه یک‌بار، تعداد کاربران و درخواست‌ها به‌سمت نشان دو برابر می‌شود و با زیرساخت ابری آروان نگرانی زیرساختی در این مسیر توسعه نیستیم.',
        author: 'مصطفی جملبادانی؛ مدیر فنی نشان',
        img: <NeshanLogo />,
    },
    {
        id: 32,
        text: 'ما در بانک پاسارگاد، به سمت استفاده از خدمات مقابله با DDoS بر بستر CDN رفتیم تا امن‌تر شویم و سرویس‌دهی سریع‌تری داشته باشیم. «دستیابی به امنیت و کاهش سطح ریسک» مهم‌ترین ارزش افزوده‌های خدمات ابر آروان برای بانک پاسارگاد بوده است.',
        author: 'نعمت الله کلانتری؛ مدیریت زیرساخت بانک پاسارگاد',
        img: <PasargadLogo />,
    },
    {
        id: 33,
        text: 'تمام خدمات تیم&nbsp;نقشه‌ی&nbsp;اسنپ که نیازمند&nbsp;CDN‌&nbsp;یا&nbsp;DNS&nbsp;است، از محصولات ابر آروان استفاده می‌کنند. روزانه میلیون‌ها کاربر تاکسی&nbsp; اسنپ، اسنپ فود، اسنپ مارکت، اسنپ&nbsp;باکس و اسنپ‌تریپ&nbsp;از نقشه‌ی اسنپ استفاده می‌کنند. با&nbsp;Load Balancer&nbsp; آروان، حدود ۹۹.۵ درصد ترافیک&nbsp;نقشه‌ی&nbsp;اسنپ صرفه‌جویی&nbsp;می‌شود.',
        author: 'علی کرمی؛ مدیر فنی نقشه اسنپ',
        img: <img src="images/customers/snapp.svg" loading="lazy" alt="اسنپ" />,
    },
    {
        id: 34,
        text: 'ابر آروان به‌معنای واقعی سرویس با کیفیت و در سطح روز دنیا عرضه می‌کند. در کنار فروش بلیت جشنواره‌ها، ما دو بلیت‌فروشی پرفشار را با استفاده از CDN ابر آروان، با موفقیت و بدون اختلال داشتیم و کاربران ما با مشکل یا کندی در وب‌سایت مواجه نشدند.',
        author: 'محمد عمروآبادی؛ مدیرعامل تیوال',
        img: <img src="images/customers/tiwall.svg" loading="lazy" alt="تیوال" />,
    },
    {
        id: 35,
        text: 'آروان باعث شده تمرکز زرین‌پال روی کار فنی خودش باشد و دغدغه‌ی زیرساختی نداریم. با گذشت زمان و بهتر شدن تیم فنی آروان، محصول هم بهبود محسوسی پیدا کرده است. من همیشه  CDN، DNS  و امنیت ابری آروان را به دوستان و مدیران کسب‌وکارها توصیه کرده‌ام و می‌کنم.',
        author: 'مصطفی امیری؛ مدیرعامل زرین‌پال',
        img: <ZarinPalLogo />,
    },
]

const CdnStatisticsData = [
    {
        id: 1,
        title: '۹۹.۹۹',
        text: 'آپ‌تایم',
        icon: <TimeIcon />
    },
    {
        id: 2,
        title: '۸۰ هزار',
        text: 'مشتری',
        icon: <UserIcon />
    },
    {
        id: 3,
        title: '۴۰',
        text: 'پاپ‌سایت',
        icon: <FlagIcon />
    },
    {
        id: 4,
        title: '۶ میلیون',
        text: 'درخواست در دقیقه',
        icon: <DocumentIcon />
    },
    {
        id: 5,
        title: '۲Tbps',
        text: 'ظرفیت مقابله با حملات',
        icon: <ShieldCheckIcon />
    },
]

export {
    HomeProducts, CustomersQuotes , CdnStatisticsData
}